'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import type { Fragment } from 'react';
import { cn } from '../../../shared/cn';
export function Listbox(t0) {
  const $ = _c(28);
  let ariaLabel;
  let autoFocus;
  let className;
  let options;
  let placeholder;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      placeholder,
      autoFocus,
      "aria-label": ariaLabel,
      children: options,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = autoFocus;
    $[3] = className;
    $[4] = options;
    $[5] = placeholder;
    $[6] = props;
  } else {
    ariaLabel = $[1];
    autoFocus = $[2];
    className = $[3];
    options = $[4];
    placeholder = $[5];
    props = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = cn(["group relative block w-full", "before:absolute before:inset-px before:rounded-[calc(var(--radius-lg)-1px)] before:bg-white before:shadow-xs", "dark:before:hidden", "focus:outline-hidden", "after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-inset data-focus:after:ring-2 data-focus:after:ring-blue-500", "data-disabled:opacity-50", className]);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== placeholder) {
    t2 = placeholder && <span className="block truncate text-zinc-500">{placeholder}</span>;
    $[9] = placeholder;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(["relative block w-full rounded-lg py-[calc(--spacing(2.5)-1px)] sm:py-[calc(--spacing(2)-1px)]", "min-h-11 sm:min-h-9", "pr-[calc(--spacing(7)-1px)] pl-[calc(--spacing(3.5)-1px)] sm:pl-[calc(--spacing(3)-1px)]", "text-left text-base/6 text-contentPrimary placeholder:text-contentTertiary sm:text-sm/6 forced-colors:text-[CanvasText]", "border border-borderPrimary group-data-active:ring-2 group-data-active:ring-blue-500", "bg-backgroundPrimary group-data-hover:bg-backgroundHoverOverlay", "group-data-hover:group-data-invalid:border-red-500 group-data-invalid:border-red-500 dark:group-data-invalid:border-red-600", "group-data-disabled:border-zinc-950/20 dark:group-data-disabled:border-white/15 dark:group-data-disabled:bg-white/[2.5%]"]);
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== options || $[13] !== t2) {
    t4 = <Headless.ListboxSelectedOption as="span" options={options} placeholder={t2} className={t3} />;
    $[12] = options;
    $[13] = t2;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"><svg className="size-5 stroke-contentSecondary sm:size-4 forced-colors:stroke-[CanvasText]" viewBox="0 0 16 16" aria-hidden="true" fill="none"><path d="M5.75 10.75L8 13L10.25 10.75" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /><path d="M10.25 5.25L8 3L5.75 5.25" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg></span>;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== ariaLabel || $[17] !== autoFocus || $[18] !== t1 || $[19] !== t4) {
    t6 = <Headless.ListboxButton autoFocus={autoFocus} data-slot="control" aria-label={ariaLabel} className={t1}>{t4}{t5}</Headless.ListboxButton>;
    $[16] = ariaLabel;
    $[17] = autoFocus;
    $[18] = t1;
    $[19] = t4;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("[--anchor-offset:-1.625rem] [--anchor-padding:--spacing(4)] sm:[--anchor-offset:-1.375rem]", "isolate z-50 w-max min-w-[calc(var(--button-width))] select-none scroll-py-1 rounded-xl p-1", "outline outline-transparent", "overflow-y-scroll overscroll-contain", "bg-backgroundPrimary", "shadow-lg ring-1 ring-zinc-950/10 dark:ring-white/10 dark:ring-inset", "transition-opacity duration-100 ease-in data-closed:data-leave:opacity-0 data-transition:pointer-events-none");
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== options) {
    t8 = <Headless.ListboxOptions transition={true} anchor="selection start" className={t7}>{options}</Headless.ListboxOptions>;
    $[22] = options;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== props || $[25] !== t6 || $[26] !== t8) {
    t9 = <Headless.Listbox {...props} multiple={false}>{t6}{t8}</Headless.Listbox>;
    $[24] = props;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}